import React, { useContext } from "react";
import { AppContext } from "../app/store";
import { FormattedMessage } from "react-intl";

export const YearlyCostContextMessage = () => {
  const {
    state: { year: planSearchYear },
  } = useContext(AppContext);
  const caleandarYear = new Date().getFullYear();
  const searchYearIsCalendarYear = Number(planSearchYear) === caleandarYear;

  return searchYearIsCalendarYear ? (
    <FormattedMessage
      id="yearly_cost.year_context"
      values={{ year: planSearchYear }}
    />
  ) : (
    <FormattedMessage
      id="yearly_cost.year_context.next_year"
      values={{ year: planSearchYear }}
    />
  );
};
